<template>
    <div class="pb-4">

            <section class="section team-section mt-4 px-4 wow fadeIn" data-wow-delay="0.3s">       
                    <div class="d-flex justify-content-around">

                        <thumb 
                            v-for="(actor, index) in actorsPerLine.actors"                           
                            @click.native="selectActor(index)" 
                            :collapseName="actorsPerLine.line" 
                            :numberOfActorsPerLine="numberOfActorsPerLine"
                            :actor="actor"
                            :isSameActorFn="isSameActorFn"
                            :key="actor.pv_id">
                        </thumb>

                    </div>
            </section> 
            <actor                
                :collapseName="this.actorsPerLine.line" 
                :actor="actor"
                :matchedSize="matchedSize" 
                :isSameLineFn="isSameLineFn"
                :isSameActorFn="isSameActorFn"
            ></actor>   

     </div>
</template>

<script>
    import { eventBus } from './../main'
    import PeopleRowThumb from './PeopleRowThumb'
    import PeopleRowActor from './PeopleRowActor'
    export default {
        components: {
            thumb: PeopleRowThumb,
            actor: PeopleRowActor
        },
        props: {
            'actorsPerLine': {
                type: Object
            },
            'numberOfActorsPerLine': {
                type: Number
            },
            'matchedSize': {
                type: String
            },
            'isSameLineFn': {
                type: Function
            },
            'isSameActorFn': {
                type: Function
            }
        },
        data () {
            return {
                actor:{}
            }
        },
        methods: {
            anchorCollapseName() {
                return '#' + this.actorsPerLine.line;
            },
            selectActor(index) {
                //alert(this.actorsPerLine.scrollTop);
                //https://stackoverflow.com/questions/871399/cross-browser-method-for-detecting-the-scrolltop-of-the-browser-window#872537
                var currentScrollTop = document.body.scrollTop || document.documentElement.scrollTop;
                if(this.actorsPerLine.lineIndex != null) {
                    var scrollTop = this.actorsPerLine.scrollTop
                    console.log("Scroll to " + scrollTop + " / current scrollTop " + currentScrollTop);
                    window.scrollTo(0, 150 + this.actorsPerLine.lineIndex * 282);
                }   

                this.actor = this.actorsPerLine.actors[index];
                if(this.actor.pv_id > -1) {
                    eventBus.$emit('selectActor', { line: this.actorsPerLine.line, actor: this.actor });
                }               
            }
        }
    }
</script>

<style >


</style>



// WEBPACK FOOTER //
// src/components/PeopleRow.vue